/* eslint-disable max-len */
import { upperFirst } from 'lodash';

export const publicApiUri = process.env.REACT_APP_PUBLIC_API_URI;

export const apiUri = process.env.REACT_APP_API_URI;

export const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;

export const userPoolWebClientId = process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID;

export const logtradeClientId = process.env.REACT_APP_LOGTRADE_CLIENT_ID;

export const logtradeRequestingParty = process.env.REACT_APP_LOGTRADE_REQUESTING_PARTY;

export const carrierName = 'transportör';

export const nonCarrierName = 'transportköpare';

export const carrierNameCapitalized = upperFirst(carrierName);

export const nonCarrierNameCapitalized = upperFirst(nonCarrierName);

export const websiteUrl = process.env.REACT_APP_WEBSITE_URL || 'http://localhost:3002';

export const websiteSearchUrl = `${websiteUrl}/hitta-transportor`; // TODO: placeholder url

export const websiteDemoUrl = `${websiteUrl}/foretag/demo`; // TODO: placeholder url

export const websiteProfileUrlBase = `${websiteUrl}/foretag`; // TODO: placeholder url
